<script>
import {application} from "@/api/projectReviewService";

export default {
    name: "NoCheckAppendFileModal",
    data(){
        return{
            visible:false,
            reviewId:undefined,
            appendFileList:[],
            confirmLoading:false,
        }
    },
    methods:{
        onSubmit(){
            if (this.appendFileList.length===0){
                this.$message.warning("请先上传文件")
                return
            }
            this.confirmLoading = true
            this.postAction({
                url: application.noCheckAppendFile,
                params: {
                    applicationId: this.reviewId,
                    files: this.appendFileList
                }
            }).then(() => {
                this.$message.success("上传成功！")
                this.confirmLoading = false
                this.onClose()
                this.$parent.loadData(1)
            })
        },
        onClose(){
            this.visible = false
        }
    }
}
</script>

<template>
    <a-modal title="上传资料" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             @cancel="onClose" :width="800">
        <a-alert type="warning" message="请上传完整版补充资料，只能上传一次" show-icon style="margin: 0 0 20px 0"></a-alert>
        <FileUpload v-model:value="appendFileList" :names="'上传资料'" :multiple="false" :size="50" :count="1" :isPdf="true"></FileUpload>
        <template #footer>
            <a-button key="back" @click="onClose">关闭</a-button>
            <a-button key="submit" type="primary" :loading="confirmLoading" @click="onSubmit">提交</a-button>
        </template>
    </a-modal>
</template>

<style scoped lang="less">

</style>
